import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import Pagar from './Pagar'
import Remote from './pages/Remote'
import Pemutar from './pages/Pemutar'
import { PenyediaBahasa } from './lib/bahasa'
import './index.css'

// ── TIGA APLIKASI, SATU BERKAS ─────────────────────────────────────────────
//
//   /        admin  — katalog, chart, pengadaan, room. Butuh login.
//   /r/KODE  tamu   — remote di HP. Tanpa login, dijaga kode sesi.
//   /p/KODE  TV     — pemutar di layar room. Tanpa login, kode yang sama.
//
// Pemilihannya dari path, bukan react-router.
//
// ── KENAPA TIDAK MEMASANG ROUTER ──────────────────────────────────────────
//
// Ada TIGA alamat dan tidak satu pun bersarang. Router menambah satu
// kebergantungan dan satu lapisan yang harus dimengerti orang berikutnya,
// untuk menggantikan tiga baris if.
//
// Yang menentukan bukan besarnya pustaka, melainkan bahwa navigasi antar
// ketiganya TIDAK PERNAH terjadi di dalam aplikasi: tamu tidak pindah ke
// admin, TV tidak pindah ke remote. Ketiganya dibuka langsung dari alamatnya,
// masing-masing di perangkat yang berbeda.
//
// Kalau suatu saat ada navigasi antar-halaman DI DALAM salah satu dari
// ketiganya, itu saatnya memasang router — bukan sekarang.
// Pagar (ErrorBoundary) dipasang PER APLIKASI, bukan satu di luar ketiganya.
//
// Rinciannya cuma ditampilkan di layar ADMIN. Tamu di HP dan TV di room tidak
// bisa berbuat apa pun dengan stack trace, dan menampilkannya di layar yang
// dilihat pengunjung bukan hal yang pantas.
function Akar() {
  const p = location.pathname
  if (p === '/r' || p.startsWith('/r/')) {
    // Bahasa hanya untuk remote tamu (HP & tablet kamar). Admin dan TV tetap
    // Bahasa Indonesia — lihat catatan di lib/bahasa.tsx.
    return <Pagar tampilkanRincian={false}><PenyediaBahasa><Remote /></PenyediaBahasa></Pagar>
  }
  // 26 Okt: '/p' tanpa garis miring juga TV — sebelumnya jatuh ke login admin,
  // padahal launcher TV & Pemutar sesudah pasang membuka persis '/p'.
  if (p === '/p' || p.startsWith('/p/')) {
    return <Pagar tampilkanRincian={false}><Pemutar /></Pagar>
  }
  return <Pagar><App /></Pagar>
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode><Akar /></React.StrictMode>,
)
